// extracted by mini-css-extract-plugin
module.exports = {"operation-logo":"operation-logo_operation-logo__3Nnw5"};